import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
import { formatAsCompleteMonthAndYear } from 'helpers/dateHelper.js';
import Label from 'components/form/Label/Label';
import React from 'react';
import classnames from 'classnames';
import FactorUpdateButton from 'components/FactorUpdateButton/index';
import FactorAddDataButton from 'components/FactorAddDataButton/index';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

export const BureauInquiryAndRefreshButtonTableComponent = props => {
  const {
    is1B,
    bureauInquiryDate,
    isDownloadAvailable,
    isPremiumUser,
    selectedBureau,
  } = props;
  return (
    <FlexContainer className={'margt10 gap-10 align-items-end'}>
      <FlexContainer className={'flex-column format100 m-format80'}>
        <FlexContainer className={'flex-column padlr10 format100'}>
          {(selectedBureau === ALL || selectedBureau === TRANS_UNION) && (
            <Label className={'text-12'}>
              Transunion Date Reported:
              {bureauInquiryDate?.transunion?.inquiryDate
                ? ' ' +
                  formatAsCompleteMonthAndYear(
                    bureauInquiryDate?.transunion?.inquiryDate,
                  )
                : ' Not Reported'}
            </Label>
          )}
        </FlexContainer>
        <FlexContainer
          className={classnames('flex-column padlr10 format100 border-rad8px', {
            bgGray005: selectedBureau === ALL || !isPremiumUser,
          })}
        >
          {(selectedBureau === ALL ||
            selectedBureau === EQUIFAX ||
            !isPremiumUser) && (
            <Label
              className={classnames('text-12 padTB4', {
                system_neutral_n250_text:
                  selectedBureau === ALL || !isPremiumUser,
              })}
            >
              Equifax Date Reported:
              {bureauInquiryDate?.equifax?.inquiryDate
                ? ' ' +
                  formatAsCompleteMonthAndYear(
                    bureauInquiryDate?.equifax?.inquiryDate,
                  )
                : ' Not Reported'}
            </Label>
          )}
          {(selectedBureau === ALL ||
            selectedBureau === EXPERIAN ||
            !isPremiumUser) && (
            <Label
              className={classnames('text-12 padTB4', {
                system_neutral_n250_text:
                  selectedBureau === ALL || !isPremiumUser,
              })}
            >
              Experian Date Reported:
              {bureauInquiryDate?.experian?.inquiryDate
                ? ' ' +
                  formatAsCompleteMonthAndYear(
                    bureauInquiryDate?.experian?.inquiryDate,
                  )
                : ' Not Reported'}
            </Label>
          )}
        </FlexContainer>
      </FlexContainer>
      {isDownloadAvailable && selectedBureau !== TRANS_UNION && (
        <FactorUpdateButton
          is1B={is1B}
          selectedBureau={selectedBureau}
          linkClassName={'format20'}
          linkConditionalName={{ 'margt20 padtb4': selectedBureau === 'ALL' }}
        />
      )}
      {!isPremiumUser && (
        <FactorAddDataButton linkClassName={'format20 padTB4'} />
      )}
    </FlexContainer>
  );
};

export const InquiryHeader = props => {
  const { basedOnBureauLabel, companyName, inquiryDate, inquiryType } = props;
  return (
    <FlexContainer className={'justify-between margb20'}>
      <FlexContainer className={'flex-column'}>
        <Label type="Other" className={'system_neutral_n250_text text-12'}>
          Company Name
        </Label>
        <Label
          type="Other"
          className={'system_neutral_n250_text text-12 margt4'}
        >
          Date Inquired
        </Label>
        <Label
          type="Other"
          className={'system_neutral_n250_text text-12 margt4'}
        >
          Type
        </Label>
        <Label className={'system_neutral_n250_text italic text-12 margt4'}>
          {basedOnBureauLabel}
        </Label>
      </FlexContainer>
      <FlexContainer className={'flex-column'}>
        <Label type="Subtitle-2" className={'bold align-self-end'}>
          {companyName}
        </Label>
        <Label
          type="Other"
          className={'align-self-end fontNeutral050 text-12 margt4'}
        >
          {inquiryDate}
        </Label>
        <Label
          type="Other"
          className={'align-self-end fontNeutral050 text-10 margt4'}
        >
          {inquiryType}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};
